import { Plugin } from '../../types';
import { getDirectInnerText } from '../../web/getDirectInnerText';
import { buildSelector } from '../../web/selector';
export const delay = (t) => new Promise(r => setTimeout(r, t))

export const click: Plugin = {
  name: 'click',
  page: (emit) => {
    document.addEventListener('click', e => {
      const now = Date.now()
      const element = e.composedPath()[0] as HTMLElement
      let selector
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()
        try {
          selector = buildSelector({
            attribute: "",
            isClick: false,
            target: element,
          })
        } catch (err) { }
        emit('click', {
          type: 'checktext',
          coords: [e.clientX, e.clientY],
          time: now,
          text: element.innerText,
          selector
        });

      }
    });
    document.addEventListener('mouseover', (e) => {
      const now = Date.now()
      const element = e.composedPath()[0] as HTMLElement
      let selector;
      try {
        selector = buildSelector({
          attribute: "",
          isClick: false,
          target: element,
        })
      } catch (_) {
        console.log('no selector found for element', element)
      }
      if (selector === 'body') {
        return
      }
      const innerText = getDirectInnerText(element).trim()
      emit('click', {
        type: 'hover',
        time: now,
        text: innerText,
        selector
      });
    }, true)
    document.addEventListener('mousedown', (e) => {
      const now = Date.now()
      const element = e.composedPath()[0] as any
      if (element.tagName === 'INPUT' && element.type === 'file') {
        return
      }
      let selector;
      try {
        selector = buildSelector({
          attribute: "",
          isClick: false,
          target: element,
        })
      } catch (_) {
        console.log('No selector found for', element)
      }
      let innerText = getDirectInnerText(element).trim()
      if (selector === 'body') {
        innerText = ''
      }
      emit('click', {
        type: 'click',
        coords: [e.clientX, e.clientY],
        time: now,
        text: innerText,
        selector
      });
    }, true);

    return () => {
      // window.document.removeEventListener(downlistener)
      // window.document.removeEventListener(uplistener)
    }
  },
  reduce(previousEvents, event) {
    const lastEvent = previousEvents.pop()
    if (lastEvent.type === 'hover' && event.type === 'click') {
      if (lastEvent.text === event.text && lastEvent.selector !== event.selector) {
        return previousEvents.concat([lastEvent, event])
      } else {
        return previousEvents.concat([event])
      }
    }
    if (lastEvent.type === 'hover' && event.type === 'hover') {
      return previousEvents.concat([event])
    }
    if (lastEvent.type === 'hover' && event.type !== 'click') {
      return previousEvents.concat([event])
    }
    if ((event.time - lastEvent.time) <= 100 && event.type === lastEvent.type) {
      return previousEvents.concat([lastEvent])
    }
    return previousEvents.concat([lastEvent, event])
  },
  rereduce(events) {
    return events.filter((e, i) => {
      if (e.type === 'hover' && events[i + 1]?.type !== 'click') {
        return false
      }
      return true
    })
  },
  generate(event, index) {
    if (event.selector) {
      event.selector = event.selector.replace(/'/gi, "\\'")
    }
    if (event.type === 'click') {
      if (event.text && !event.selector) {
        return `
        it("${index}. clicks on \`${event.text.replace(/"/gi, '\\"')}\`", async () => {
          await expect(page).toClick('${event.selector || ''}:text-is("${event.text.trim()}")')
        })
        `
      }
      if (event.selector) {
        return `
        it("clicks on \`${event.selector.replace(/"/gi, '\\"')}\`", async () => {
          await expect(page).toClick('${event.selector.replace(/'/g, '"')}')
        })
        `
      }
      return `
      it("clicks on coordinates \`x: ${event.coords[0]}, y:${event.coords[1]}\`", async () => {
        await expect(page).toClick([${event.coords[0]},${event.coords[1]}])
      })`
    } else if (event.type === 'checktext') {
      return `
      it("has text \`${event.text.replace(/"/gi, '\\"')}\`", async () => {
          await expect(page).toHaveText(${event.selector ? `'${event.selector.replace(/'/g, '"')}',` : ''}'${event.text}')
      })
      `
    } else if (event.type === 'hover') {
      if (event.text && event.text.split('\n').length === 1) {
        return `
        it("hovers over \`${event.text.replace(/"/gi, '\\"')}\`", async () => {
          await expect(page).toHoverOver('${event.selector || ''}:text-is("${event.text}")')
        })
        `
      }
      if (event.selector) {
        return `
        it("hovers over \`${event.selector.replace(/"/gi, '\\"')}\`", async () => {
          await expect(page).toHoverOver('${event.selector.replace(/'/g, '"')}')
        })
        `
      }
    }
    return ''
  },
  test: {
    matchers: {
      toHoverOver: async (page, selector) => {
        try {
          await page.hover(selector);
          return { pass: true, message: () => "Page hovers over " + selector };
        } catch (err) {
          return {
            pass: false,
            message: () => "Page did not hover over " + selector,
          };
        }
      },
      toClick: async (page, selector) => {
        try {
          if (typeof selector === 'object') {
            await delay(500)
            await page.waitForLoadState()
            await page.mouse.click(selector[0], selector[1])
          } else {
            await page.waitForLoadState('networkidle');
            await page.waitForTimeout(200)
            await page.click(selector);
          }
          return { pass: true, message: () => "Page click " + selector };
        } catch (err) {
          return {
            pass: false,
            message: () => "Page did not click " + selector,
          };
        }
      }
    },

  }
};

export default click